import { useSelector } from "react-redux";

/**
 * Hook that returns whether the current user can perform CRUD actions.
 * Admins and verified users are allowed; unverified users are blocked.
 */
export function useVerificationGuard() {
  const { user } = useSelector((state) => state.user);
  return user?.emailVerified || user?.role === "ADMIN";
}

export const VERIFY_MSG =
  "Please verify your email address before performing this action. Check your inbox for the verification link.";
